"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = buildInputProps;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty")),
    _lodash = _interopRequireDefault(require("lodash.omit")),
    _Input = require("../../../common/styles/Input");

function ownKeys(a, b) {
  var c = Object.keys(a);

  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(a);
    b && (d = d.filter(function (b) {
      return Object.getOwnPropertyDescriptor(a, b).enumerable;
    })), c.push.apply(c, d);
  }

  return c;
}

function _objectSpread(a) {
  for (var b, c = 1; c < arguments.length; c++) {
    b = null == arguments[c] ? {} : arguments[c], c % 2 ? ownKeys(Object(b), !0).forEach(function (c) {
      (0, _defineProperty2["default"])(a, c, b[c]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : ownKeys(Object(b)).forEach(function (c) {
      Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
    });
  }

  return a;
}

var OMITTED_PROPS = ["label", "prefix", "suffixIcon", "clearButton", "errorMessage", "className", "allSuggestions", "renderSuggestion", "multiline", "defaultValue", "valid", "validate", "styleType", "small"];

function buildInputProps(a) {
  var b = a.calculatedSuffixIcon,
      c = a.valid,
      d = a.allProps,
      e = a.onFocus,
      f = a.onBlur,
      g = a.onChange,
      h = a.styleType,
      i = a.small,
      j = d.prefix,
      k = d.allSuggestions,
      l = d.disabled;
  return _objectSpread({
    className: (0, _Input.INPUT)({
      valid: c,
      disabled: l,
      hasPrefix: !!j,
      hasSuffix: !!b,
      hasAutoComplete: !!k,
      styleType: h,
      small: i
    })
  }, (0, _lodash["default"])(d, OMITTED_PROPS), {
    onFocus: e,
    onBlur: f,
    onChange: g
  });
}